export const messages = {
  en: {
    searchStaff: {
      title: 'Locate Staff',
      staffCode: 'Staff Code',
      staffName: 'Staff Name',
      phone: 'Phone',
      gender: 'Gender',
      operation: 'Operation',
      select: 'Select',
      inputPlaceholder: 'Enter staff name',
      search: 'Search',
      male: 'Male',
      female: 'Female'
    }
  },
  zh: {
    searchStaff: {
      title: '定位员工',
      staffCode: '员工编码',
      staffName: '员工姓名',
      phone: '手机号',
      gender: '性别',
      operation: '操作',
      select: '选择',
      inputPlaceholder: '输入员工名称',
      search: '查询',
      male: '男',
      female: '女'
    }
  }
}